<script lang="ts">
    import SearchFilters from '$saga/views/Search/SearchFilters.svelte';

    export let openAccordions: boolean;
</script>

<SearchFilters {openAccordions} />
